import { render } from "./InputReadersSuffix.vue?vue&type=template&id=22ef8cbe"
import script from "./InputReadersSuffix.vue?vue&type=script&lang=ts"
export * from "./InputReadersSuffix.vue?vue&type=script&lang=ts"
script.render = render

export default script